'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _gregorianCalendarFormatLibLocaleZh_CN = require('gregorian-calendar-format/lib/locale/zh_CN');

var _gregorianCalendarFormatLibLocaleZh_CN2 = _interopRequireDefault(_gregorianCalendarFormatLibLocaleZh_CN);

var _gregorianCalendarLibLocaleZh_CN = require('gregorian-calendar/lib/locale/zh_CN');

var _gregorianCalendarLibLocaleZh_CN2 = _interopRequireDefault(_gregorianCalendarLibLocaleZh_CN);

exports['default'] = {
  clear: '清除',
  format: _gregorianCalendarFormatLibLocaleZh_CN2['default'],
  calendar: _gregorianCalendarLibLocaleZh_CN2['default']
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-time-picker/lib/locale/zh_CN.js
 ** module id = 476
 ** module chunks = 0
 **/